import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const NavbarTwo = () => {
  const [active, setActive] = useState(false);
  const [searchShow, setSearchShow] = useState(false);
  const menuActive = () => {
    setActive(!active);
  };
  const searchActive = () => {
    setSearchShow(!searchShow);
  };

  // Function to handle smooth scrolling to sections
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };
  return (
    <>
      {/* search popup start*/}
      <div
        className={searchShow ? 'td-search-popup active' : 'td-search-popup '}
        id="td-search-popup"
      >
        <form action="/" className="search-form">
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              placeholder="Search....."
            />
          </div>
          <button type="submit" className="submit-btn">
            <FaSearch />
          </button>
        </form>
      </div>
      {/* search popup end*/}
      <div
        onClick={searchActive}
        className={searchShow ? 'body-overlay active' : 'body-overlay'}
        id="body-overlay"
      ></div>
      {/* ==================== Navbar Two Start ====================*/}
      <nav className="navbar navbar-area navbar-area_2 navbar-area-2 navbar-expand-lg">
        <div className="container nav-container">
          <div className="responsive-mobile-menu">
            <button
              onClick={menuActive}
              className={
                active
                  ? 'menu toggle-btn d-block d-lg-none open'
                  : 'menu toggle-btn d-block d-lg-none'
              }
              data-target="#itech_main_menu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-left" />
              <span className="icon-right" />
            </button>
          </div>
          <div className="logo">
            <Link to="/">
              <img 
                src="assets/img/firmascheck-logo.png" 
                alt="FirmasCheck - Firma electrónica segura" 
                style={{maxHeight: '60px', width: 'auto'}}
              />
            </Link>
          </div>
          <div className="nav-right-part nav-right-part-mobile">
            <span className="search-bar-btn" onClick={searchActive}>
              <FaSearch />
            </span>
          </div>
          <div
            className={
              active
                ? 'collapse navbar-collapse sopen'
                : 'collapse navbar-collapse'
            }
            id="itech_main_menu"
          >
            <ul className="navbar-nav menu-open text-lg-end">
              <li>
                <button 
                  onClick={() => scrollToSection('producto')}
                  className="nav-link section-jump-link"
                >
                  Producto
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('como-funciona')}
                  className="nav-link section-jump-link"
                >
                  Cómo funciona
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('seguridad')}
                  className="nav-link section-jump-link"
                >
                  Seguridad
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('precios')}
                  className="nav-link section-jump-link"
                >
                  Precios
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('faq')}
                  className="nav-link section-jump-link"
                >
                  FAQ
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contacto')}
                  className="nav-link section-jump-link"
                >
                  Contáctanos
                </button>
              </li>
              <li className="nav-cta-mobile d-lg-none">
                <a
                  href="https://app.firmascheck.cl"
                  className="btn btn-base nav-login-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ingresar
                </a>
              </li>
            </ul>
          </div>
          <div className="nav-right-part nav-right-part-desktop nav-cta-group align-self-center">
            <a
              href="https://app.firmascheck.cl"
              className="btn btn-base nav-login-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ingresar
            </a>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="btn btn-border-base"
            >
              Contáctanos →
            </button>
          </div>
        </div>
      </nav>
      {/* ==================== Navbar Two end ====================*/}
    </>
  );
};

export default NavbarTwo;
